import React from 'react';
import './Main.scss';

import Header from 'components/Header';
import Footer from 'components/Footer';

export default class MainTemplate extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <Header />
                <div className="container body">
                    <div className="main_container clearfix">
                        {this.props.children}
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Templates/Main/index.js